import { render, staticRenderFns } from "./ServicePointDetailDeviceDetails.vue?vue&type=template&id=53624628&scoped=true&"
import script from "./ServicePointDetailDeviceDetails.vue?vue&type=script&lang=ts&"
export * from "./ServicePointDetailDeviceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointDetailDeviceDetails.vue?vue&type=style&index=0&id=53624628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53624628",
  null
  
)

export default component.exports